import * as React from "react";
import { Provider } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { store } from "../redux/store";
import { Layout } from "../view/containers/Layout/Layout";
import { Login } from "../view/pages/Login/Login";
import { ForgotPassword } from "../view/pages/ForgotPassword/ForgotPassword";
import { ResetPassword } from "../view/pages/ResetPassword/ResetPassword";
import { GlobalRoutes } from "./NavConstant";
import { Page404 } from "../view/pages/Page404/Page404";
import "react-toastify/dist/ReactToastify.css";
import "../core/translation";
export default function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route path="*" element={<Layout />} />
        <Route path={GlobalRoutes.LOGIN} element={<Login />} />
        <Route
          path={GlobalRoutes.ForgotPassword}
          element={<ForgotPassword />}
        />
        <Route path={GlobalRoutes.ResetPassword} element={<ResetPassword />} />
        <Route path="/404" element={<Page404 />} />
      </Routes>
    </Provider>
  );
}
